export default "__VITE_ASSET__BOomhbBi__"